import { ChildCare } from '@js/data-models';
import { ft } from '@js/definitions';
import { FortyTwoLoginService } from '@js/FortyTwoFramework';
import { AppService } from '@js/services/FT.app.services.appservice';
import { DataService } from '@js/services/FT.app.services.dataservice';
import { IScope } from 'angular';
import { IStateParamsService, IStateService } from 'angular-ui-router';


interface Scope extends IScope {
    switchLanguage(lang: string): void;

    isLoading: boolean;
    currentYear: number;
    appData: any;
}

class GotoAppController {
    public static $inject = ['$scope', '$state', '$stateParams', '$translate', 'AppService', 'DataService', 'LoginService'];

    private $scope: Scope;
    private $state: IStateService;
    private $translate: any;
    private appService: AppService;
    private dataService: DataService;
    private loginService: FortyTwoLoginService;

    constructor($scope: Scope, $state: IStateService, $stateParams: IStateParamsService, $translate: any, appService: AppService, dataService: DataService, loginService: FortyTwoLoginService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
        this.appService = appService;
        this.dataService = dataService;
        this.loginService = loginService;

        $scope.isLoading = false;
        $scope.currentYear = new Date().getFullYear();
        $scope.appData = appService.data;

        if ($stateParams.lang) {
            appService.switchLanguage($stateParams.lang);
        }

        this.$scope.switchLanguage = this.switchLanguage.bind(this);
    }

    private switchLanguage(lang: string): void {
        this.appService.switchLanguage(lang);
    }
}

ft.app.controller('gotoappController', GotoAppController);